import { useEffect, useRef } from "react";

export default function WebCanvas() {
    const ref = useRef(null);

    useEffect(() => {
        const canvas = ref.current;
        const ctx = canvas.getContext("2d");
        let raf;
        let nodes = [];
        const mouse = { x: -9999, y: -9999 };

        const resize = () => {
            const { clientWidth: w, clientHeight: h } = canvas.parentElement;
            const dpr = Math.min(window.devicePixelRatio || 1, 2);
            canvas.width = w * dpr;
            canvas.height = h * dpr;
            canvas.style.width = `${w}px`;
            canvas.style.height = `${h}px`;
            ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
            nodes = [];
            const gap = 95;
            for (let x = gap / 2; x < w; x += gap) {
                for (let y = gap / 2; y < h; y += gap) {
                    nodes.push({
                        x: x + (Math.random() - 0.5) * 30,
                        y: y + (Math.random() - 0.5) * 30,
                    });
                }
            }
        };

        const onMove = (e) => {
            const r = canvas.getBoundingClientRect();
            mouse.x = e.clientX - r.left;
            mouse.y = e.clientY - r.top;
        };
        const onLeave = () => {
            mouse.x = -9999;
            mouse.y = -9999;
        };

        const draw = () => {
            const w = canvas.clientWidth;
            const h = canvas.clientHeight;
            ctx.clearRect(0, 0, w, h);
            for (let i = 0; i < nodes.length; i++) {
                const a = nodes[i];
                for (let j = i + 1; j < nodes.length; j++) {
                    const b = nodes[j];
                    const dx = a.x - b.x;
                    const dy = a.y - b.y;
                    const d = Math.hypot(dx, dy);
                    if (d < 130) {
                        const dm = Math.hypot(
                            (a.x + b.x) / 2 - mouse.x,
                            (a.y + b.y) / 2 - mouse.y
                        );
                        const boost = dm < 220 ? 0.55 : 0;
                        const alpha = 0.05 + (1 - d / 130) * 0.09 + boost;
                        ctx.strokeStyle = `rgba(230, 0, 38, ${alpha})`;
                        ctx.lineWidth = dm < 220 ? 1 : 0.6;
                        ctx.beginPath();
                        ctx.moveTo(a.x, a.y);
                        ctx.lineTo(b.x, b.y);
                        ctx.stroke();
                    }
                }
                const dm = Math.hypot(a.x - mouse.x, a.y - mouse.y);
                if (dm < 220) {
                    ctx.strokeStyle = `rgba(255, 30, 39, ${0.35 * (1 - dm / 220)})`;
                    ctx.lineWidth = 1;
                    ctx.beginPath();
                    ctx.moveTo(a.x, a.y);
                    ctx.lineTo(mouse.x, mouse.y);
                    ctx.stroke();
                }
                ctx.fillStyle = "rgba(230, 0, 38, 0.5)";
                ctx.fillRect(a.x - 1, a.y - 1, 2, 2);
            }
            raf = requestAnimationFrame(draw);
        };

        resize();
        draw();
        window.addEventListener("resize", resize);
        canvas.parentElement.addEventListener("mousemove", onMove);
        canvas.parentElement.addEventListener("mouseleave", onLeave);
        return () => {
            cancelAnimationFrame(raf);
            window.removeEventListener("resize", resize);
            canvas.parentElement?.removeEventListener("mousemove", onMove);
            canvas.parentElement?.removeEventListener("mouseleave", onLeave);
        };
    }, []);

    return <canvas ref={ref} className="absolute inset-0 z-0" aria-hidden="true" />;
}
